(function () {

    a3_cabin_reports.directive('aimsCrewMemos', aimsCrewMemos);

    /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name aimsCrewMemos
   * @restrict E
   * @description
   *   Implementation of aimsCrewMemos
   *   Initialize the Aims Crew Memos
   * @example
   *   Usage:
   *   <aims-crew-memos  date="date"></aimsCrewMemos>
   * @ngInject
   */
    function aimsCrewMemos(AimsCrewMemosFactory) {
        function link($scope, element, attrs) {
          $scope.aimsCrewMemos = AimsCrewMemosFactory.getAimsCrewMemosByDate(attrs.date);
            
        }

        return {
            restrict: 'E',
            templateUrl: "views/directives/aimsCrewMemos.tpl.html",
            scope: true,
            terminal: true,
            link: link
        }
    }
})();